import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";
import portrait from "../../Assets/oguzhan-ozcelik.jpeg";

const ROLES = [
  "Full-Stack Developer",
  "Shopify Expert",
  "React & Node Engineer",
  "Performance · SEO · DX",
];

export default function Hero() {
  const [roleIdx, setRoleIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setRoleIdx((i) => (i + 1) % ROLES.length);
    }, 2400);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero__bg" aria-hidden="true" />
      <div className="container-x hero__inner">
        <div className="reveal">
          <span className="eyebrow">Portfolio · 2026</span>

          <h1 className="hero__title">
            <span className="stroke">Hi, I'm</span>
            <br />
            Oguzhan <span className="it accent">Ozcelik</span>
            <br />
            <span className="serif-it">— call me Ozzy.</span>
          </h1>

          <p className="hero__sub">
            I'm a full-stack developer & Shopify expert based in New York, US.
            I design and build <strong>fast, reliable e-commerce experiences</strong>{" "}
            and web applications — from React storefronts and Liquid themes to
            Node and Laravel APIs.
          </p>

          <div className="hero__cta">
            <Link to="/project" className="btn">
              View Projects
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
            <Link to="/contact" className="btn btn--ghost">
              Hire me
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
          </div>

          <div className="hero__meta">
            <div className="hero__meta-item">
              <span className="label">Status</span>
              <span className="value">
                <span className="live-dot" />
                Open to work
              </span>
            </div>
            <div className="hero__meta-item">
              <span className="label">Currently</span>
              <span className="value" key={roleIdx} style={{ transition: "opacity 300ms" }}>
                {ROLES[roleIdx]}
              </span>
            </div>
            <div className="hero__meta-item">
              <span className="label">Based in</span>
              <span className="value">New York, US</span>
            </div>
          </div>
        </div>

        <div className="hero__visual reveal">
          <div className="hero__photo-wrap">
            <img src={portrait} alt="Oguzhan Ozcelik portrait" loading="eager" />
            <div className="hero__photo-tag">
              <span>Full-Stack Engineer</span>
              <span><b>10+</b>&nbsp;yrs experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
